module.exports = __webpack_public_path__ + "static/media/training.afc3b6b2.svg";